import React, {useState,useEffect} from 'react';   
import { addToCart,removeFromCart } from '../../redux/slices/CartSlice';
import { addToWishList, removeFromWishList } from '../../redux/slices/AuthSlice';
import { useDispatch,useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit'; 
import SareesProductViewModal from './ProductViewModal';
import KurtisProductViewModal from '../Womens/ProductViewModal';
import { Tooltip } from 'react-tooltip';
import { useParams } from 'react-router-dom';
import data from '../../assets/bootstrap/js/src/dom/data';
import { loginModalOpen } from '../../redux/slices/AuthSlice';

const  ProductDetails = () => {
  const {wishlist_ids,loggedInUser} = useSelector((state:any) => state.auth)
  const {cart} = useSelector((state:any) => state.cart)
 // const {tShirtSettings} = useSelector((state:any) => state.settings)
  const [selectedProduct,setSelectedProduct] = useState('' as any)
  const dispatch = useDispatch<ThunkDispatch<any,any,any>>();
  const [modalShow, setModalShow] = useState(true);
  //const [loginModalShow, setLoginModalShow] = useState(false);
  const { productId } = useParams();
  const lineItemIds =  cart?.['line_items']?.map(a => a.variant_id);
  const [loading, setLoading] = useState(true); 
   const [statusMsg,setStatusMsg] = useState('');
 
    useEffect(() => {
  
      const fetchProduct = async () => {
        setLoading(true);
        try {
          const response = await fetch(process.env.REACT_APP_SERVER_URL + `/api/v1/products/${productId}`);
          
          // Check if the response is OK (status code 200-299)
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
      
          const data = await response.json(); // Parse the JSON data
          //console.log("data",data)
          if (data.status === 'success'){
            setSelectedProduct(data.data); 
          }
          else{
            setStatusMsg(data.message)
          }
        } catch (error) {
          console.error("Error fetching items:", error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchProduct();
    }, []);

 
  const handleModalClose = () => {
    setModalShow(false)
  }

  const handleModal= (product) => {
      setModalShow(true)
      setSelectedProduct(product);
  }

  const manageWishList = (product_id,type) => {
    if (loggedInUser === null){
      dispatch(loginModalOpen("User"))
    }
    else{ 
      if(type === "Add"){
        dispatch(addToWishList(product_id))
      }
      if(type === "Remove"){
        dispatch(removeFromWishList(product_id))
      }
    }

  }

  const manageCart = (variant_id,qty,price,actualPrice) => {
    if( lineItemIds?.includes(variant_id)){
      const lineItem = cart['line_items'].filter((line_item) => line_item.variant_id === variant_id ) 
      dispatch(removeFromCart(lineItem[0].id))
    } 
    else{
      dispatch(addToCart({variant_id,qty,price,actualPrice}))
    }    
  }
 //console.log("jjjjjjjjjjjj",selectedProduct)
  return (
    <>
        <div className='container errorMsg'>{statusMsg}</div>
        {selectedProduct && selectedProduct.subcategory.name === "Sarees" && <SareesProductViewModal selectedProduct={selectedProduct} modalShow={modalShow} onClose={handleModalClose} wishListData={manageWishList} wishlistIds={wishlist_ids}/>}
        {selectedProduct && selectedProduct.subcategory.name !== "Sarees" && <KurtisProductViewModal selectedProduct={selectedProduct} modalShow={modalShow} onClose={handleModalClose} wishListData={manageWishList} wishlistIds={wishlist_ids}/>}
       
    </> 
  );
}

export default ProductDetails;

 
